import { ModuleWithProviders, NgModule } from "@angular/core";
import { InovaNavComponent } from "./inova-nav/inova-nav.component";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavEnvironment, NAV_ENVIRONMENT } from "./public-api";
import { ApolloClientOptions } from "apollo-client";
import { HttpLink, HttpLinkModule } from "apollo-angular-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloModule } from "apollo-angular";
import { HttpClientModule } from "@angular/common/http";
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { CommonModule } from "@angular/common";
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from "@ngx-translate/core";
import { InovaNavGraphqlApi } from "./services/nav-api.service";

@NgModule({
  declarations: [InovaNavComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    ApolloModule,
    HttpLinkModule,
    HttpClientModule,
    TranslateModule
  ],
  exports: [InovaNavComponent],
  providers: [InovaNavGraphqlApi],
})
export class InovaCoreNavModule {
  static forRoot(navEnv: NavEnvironment): ModuleWithProviders<InovaCoreNavModule> {
    return {
      ngModule: InovaCoreNavModule,
      providers: [
        { provide: NAV_ENVIRONMENT, useValue: navEnv }
      ]
    };
  }
}





export function createApolloConfigFor(httpLink: HttpLink, uri: string, headers: any): ApolloClientOptions<any> {
  const auth = setContext((operation, context) => ({
    headers: headers,
  }));
  const config: ApolloClientOptions<any> = {
    link: ApolloLink.from([auth, httpLink.create({ uri })]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
    ...headers && { headers: headers },
  }
  return config;
}